import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoNivelAcademicoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoNivelAcademicoPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoNivelAcademico(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'TipoNivelAcademico', name: 'TipoNivelAcademico', title: 'Tipo Nivel Academico' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            // unidadAcademicas: [],
            tiponivelacademico: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoNivelAcademico() {
            this.tiponivelacademico = {};
            this.$refs['frm-tiponivelacademico'].show();
        },
        showTipoNivelAcademico(id) {
            console.log("show");
            
            this.isLoading=true;
            this.ss.showTipoNivelAcademico(id).then(
                (result) => {
                    let response = result.data;
                    this.tiponivelacademico = response.data;
                    this.$refs['view-tiponivelacademico'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoNivelAcademico() {
            this.$refs['frm-tiponivelacademico'].show();
            this.$refs['view-tiponivelacademico'].hide();
        },
        cancelTipoNivelAcademico() {
            if (this.tiponivelacademico.id) {
                this.$refs['view-tiponivelacademico'].show();
            }
            this.$refs['frm-tiponivelacademico'].hide();
        },
        saveTipoNivelAcademico() {
            this.ss.storeTipoNivelAcademico(this.tiponivelacademico).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tiponivelacademico'].hide();
                    this.$refs['datatable-tiponivelacademico'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        destroyTipoNivelAcademico() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoNivelAcademico(this.tiponivelacademico)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tiponivelacademico'].hide();
                                this.$refs['datatable-tiponivelacademico'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoNivelAcademico').on('click', (evt) => {
                console.log("evento click");
                const data = window.$(evt.target)[0].id;
                this.showTipoNivelAcademico(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
